export default "__VITE_ASSET__0221033b__"